/**
 * Is there an intersection of the two arrays?
 */
export function intersects(array1: any[], array2: any[]): boolean {
  return !!array1.find((el) => array2.includes(el));
}

/**
 * Returns the array of elements existing in both of two arrays.
 */
export function intersection<T>(array1: T[], array2: T[]): T[] {
  return array1.filter((el) => array2.includes(el));
}
